import NewCourseDetails from '../../components/newcourseDetails/CourseDetails.vue'

export default {
    data() {
        return {
            // 板块数组
            sections: [],
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 15,
            // 总条数
            total: 0,
			
		}
    },
	components:{NewCourseDetails},
    methods: {
		//获取首页数据
		getdata() {
		    //获取板块信息
		    this.$getStoreId().then(id => {
		        this.$post('product_category/search_products', {
		            shop_id: id,
		            available: 1,
		            offset: (this.currentPage - 1) * this.pageSize,
		            length: this.pageSize
		        }).then(res => {
		            this.sections = res.data.result.data;
		            this.total = res.data.result.total;
		            //因为返回的对象里面的数组有产品数组，也有项目包数组，若
		            // this.sections.map(item => {
		            //     //若产品数组为空则删除产品数组这个属性
		            //     // if (item.product_category_mapping.length == 0) {
		            //     //     item.section_products = item.package_section;
		            //     // }
		            //     //删除项目包数组这个属性
		            //     delete item.package_section;
		            // })
		            // 请求得到的数据的操作  
		            // console.log(this.sections);
		        })
		    })
		
		},
		// 每页显示数目变化时调用
		handleSizeChange(pageSize) {
		    this.pageSize = pageSize;
		    this.getdata();
		},
		
		// 当前页改变时调用
		handleCurrentChange(currentPage) {
		    this.currentPage = currentPage;
		    this.getdata()
		}
    },
    created() {
		this.getdata()
	}
}